<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">Perfil de Usuario</h1>
        <p class="section-subtitle">
          Gestiona tu información personal y configuración de cuenta
        </p>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content">
    <div class="space-y-6">
      <app-user-meta-card [usuario]="usuario"/>
      <app-user-info-card [usuario]="usuario"/>

      <!-- Sección de Cambio de Contraseña -->
      <app-component-card title="Cambiar Contraseña">
        <div class="mb-4">
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Actualiza tu contraseña para mantener tu cuenta segura
          </p>
        </div>

        <form [formGroup]="formCambioPassword" (ngSubmit)="cambiarPassword()">
          <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
            <!-- Contraseña Actual -->
            <div>
              <app-label htmlFor="oldPassword" [required]="true">Contraseña Actual</app-label>
              <div class="relative">
                <input pInputText id="oldPassword" formControlName="oldPassword"
                  [type]="showOldPassword() ? 'text' : 'password'" placeholder="••••••••"
                  class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                  [class.border-red-500]="formCambioPassword.get('oldPassword')?.invalid && formCambioPassword.get('oldPassword')?.touched" />
                <button type="button" (click)="togglePasswordVisibility('oldPassword')"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                  <i [class]="showOldPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
              </div>
              @if (formCambioPassword.get('oldPassword')?.invalid && formCambioPassword.get('oldPassword')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                Contraseña actual es requerida
              </small>
              }
            </div>

            <!-- Nueva Contraseña -->
            <div>
              <app-label htmlFor="newPassword" [required]="true">Nueva Contraseña</app-label>
              <div class="relative">
                <input pInputText id="newPassword" formControlName="newPassword"
                  [type]="showNewPassword() ? 'text' : 'password'" placeholder="••••••••"
                  class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                  [class.border-red-500]="formCambioPassword.get('newPassword')?.invalid && formCambioPassword.get('newPassword')?.touched" />
                <button type="button" (click)="togglePasswordVisibility('newPassword')"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                  <i [class]="showNewPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
              </div>
              @if (formCambioPassword.get('newPassword')?.invalid && formCambioPassword.get('newPassword')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                @if (formCambioPassword.get('newPassword')?.errors?.['required']) {
                Nueva contraseña es requerida
                }
                @if (formCambioPassword.get('newPassword')?.errors?.['minlength']) {
                Debe tener al menos 7 caracteres
                }
              </small>
              }
            </div>

            <!-- Confirmar Nueva Contraseña -->
            <div>
              <app-label htmlFor="newRetypedPassword" [required]="true">Confirmar Nueva Contraseña</app-label>
              <div class="relative">
                <input pInputText id="newRetypedPassword" formControlName="newRetypedPassword"
                  [type]="showNewRetypedPassword() ? 'text' : 'password'" placeholder="••••••••"
                  class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                  [class.border-red-500]="formCambioPassword.get('newRetypedPassword')?.invalid && formCambioPassword.get('newRetypedPassword')?.touched" />
                <button type="button" (click)="togglePasswordVisibility('newRetypedPassword')"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                  <i [class]="showNewRetypedPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
              </div>
              @if (formCambioPassword.get('newRetypedPassword')?.invalid &&
              formCambioPassword.get('newRetypedPassword')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                Debe confirmar la nueva contraseña
              </small>
              }
            </div>
          </div>

          <!-- Mensaje de error si las contraseñas no coinciden -->
          @if (formCambioPassword.errors?.['passwordsMismatch'] && formCambioPassword.dirty) {
          <div class="mt-4 rounded-lg bg-red-50 p-4 dark:bg-red-900/20">
            <div class="flex items-start gap-3">
              <svg class="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              <p class="text-sm text-red-700 dark:text-red-400">
                Las contraseñas no coinciden
              </p>
            </div>
          </div>
          }

          <div class="mt-6 flex justify-end">
            <button pButton type="submit" label="Cambiar Contraseña" icon="pi pi-key" [loading]="loading()"
              [disabled]="formCambioPassword.invalid || loading()"></button>
          </div>
        </form>
      </app-component-card>
    </div>
  </div>
</div>